<template>
  <div class="">
    <ListAllRequests v-if="step===1"
                     :isAdmin="isAdmin"
                     :companyId="companyId"
                     @setQuickFilterCompany="setQuickFilterCompany"
                     @setGeneralData="setGeneralData"
                     @placeOrder="placeOrder"
                     @toggleLoading="toggleLoading"></ListAllRequests>
    <ListPlaceOrderResult v-if="step===2"
                          :selectedRequestToOrder="selectedRequestToOrder"
                          :selectedFilters="selectedFilters"
                          :isAdmin="isAdmin"
                          :companyId="companyId"
                          :companyDeliveryAddresses="companyDeliveryAddresses"
                          @reStartFlow="reStartFlow"
                          @setGeneralData="setGeneralData"
                          @displaySuccessScreen="displaySuccessScreen"
                          @toggleLoading="toggleLoading"></ListPlaceOrderResult>
    <SuccessPlaceOrders v-if="step===3"
                        :countPlacedOrders="successfulOrderTotal"
                        :scope="'card'"
                        :isAdmin="isAdmin"
                        @reStartFlow="reStartFlow"/>
    <content-loader :loaderVisible="loading" :loaderError="loaderError"></content-loader>
  </div>
</template>

<script>
import httpFlexbenService from "@/http/http-flexben";
import ListAllRequests from "@/components/flexben/requests/card/partials/ListAllRequests";
import SuccessPlaceOrders from "@/components/flexben/requests/partials/SuccessPlaceOrders";
import ListPlaceOrderResult from "@/components/flexben/requests/card/partials/ListPlaceOrderResult";

export default {
  name: "CardRequestsSteps",
  components: {
    SuccessPlaceOrders,
    ListAllRequests,
    ListPlaceOrderResult
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
      required: true,
    },
    companyId: {
      type: Number,
    },
  },
  data: function () {
    return {
      loading: false,
      loaderError: false,
      httpService: httpFlexbenService.requests,
      selectedRequestToOrder: {},
      companyDeliveryAddresses: {},
      selectedFilters: {
        company: null,
        benefit: null,
        beneficiary: null,
        start_date: null,
        end_date: null,
        company_address: null,
      },
      step: 1,
      successfulOrderTotal: 0
    };
  },
  methods: {
    setGeneralData() {
      this.$emit('setGeneralData');
    },
    placeOrder(requests, selectedFilters, companyDeliveryAddresses) {
      if (this.checkNotEmptyObj(requests) && this.companyId !== null) {
        this.scrollToTop();
        this.selectedRequestToOrder = requests;
        this.selectedFilters = selectedFilters;
        this.companyDeliveryAddresses = companyDeliveryAddresses;
        this.step = 2;
      }
    },
    toggleLoading(value, loaderError = false) {
      this.loading = value;
      this.loaderError = loaderError;
    },
    setQuickFilterCompany(companyId) {
      this.$emit('setQuickFilterCompany', companyId);
    },
    reStartFlow() {
      this.step = 1;
      this.setGeneralData();
    },
    displaySuccessScreen(successfulOrderTotal) {
      this.successfulOrderTotal = successfulOrderTotal;
      this.step = 3;
    }
  }
}
</script>
